import { render, staticRenderFns } from "./packageConfirmation.vue?vue&type=template&id=9a57b2c4&"
import script from "./packageConfirmation.vue?vue&type=script&lang=js&"
export * from "./packageConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports